/**
 * Controls whether or not we fetch data from the server on the logged out search page
 * Product Area: WEB_RETAILER_SERVER
 */
export const NEXTJS_RSC_LOGGED_OUT_SEARCH_PAGE_240514 = 'NEXTJS_RSC_LOGGED_OUT_SEARCH_PAGE_240514';
